export default {
  "session_create_server": "On {{name}}",
  "session_create_close": "Close session creation",
  "sandbox_about": "About sandbox mode",
  "choose_agent": "Choose an agent",
  "agent_start_failed": "Failed to start {{agent}} session: {{detail}}",
  "session_creation_dialog_open": "Session creation dialog open",
  "sandbox_agents_help": "Sandbox mode controls Claude Code, Codex, Antigravity and Kimi approvals. Pi and OpenCode use their own permission settings and may run tools without asking.",
  "sandbox_kimi_help": "Kimi will use --auto: it decides actions and questions automatically; Plan mode can still pause.",
  "sandbox_other_agents_help": "Pi and OpenCode use their own permission settings; this switch does not change them. They may run tools without asking in either mode.",
  "agents_none_installed": "No agents installed.",
  "miniapp_buy_starter": "⭐️ Buy Starter",
  "miniapp_all_plans": "All Plans",
  "preview_invalid_link": "Invalid preview link.",
  "preview_bot_only": "Open this file preview from the Telegram bot.",
  "preview_preparing": "Preparing Telegram file preview.",
  "preview_unlinked": "Telegram not linked",
  "preview_file_unavailable": "File unavailable",
  "preview_copy_code": "Copy code",
  "gateway_update_timeout": "Gateway update to {{version}} timed out",
  "agent_install_timeout": "{{agent}} installation timed out. Try again in a moment.",
  "agent_update_timeout": "{{agent}} update to {{version}} timed out",
  "agent_update_failed": "Failed to update {{agent}}: {{detail}}",
  "session_status_starting": "starting",
  "session_status_running": "running",
  "session_status_ended": "ended",
  "session_status_closed": "closed",
  "session_status_failed": "failed",
  "session_status_ending": "ending",
  "session_unavailable_status": "This session is {{status}} and cannot be reopened from Telegram.",
  "session_current_status": "Session is {{status}} right now.",
  "transfer_size_limit": "File exceeds the {{size}} MB limit.",
  "premium_by": "by {{brand}}",
  "operating_system": "OS",
  "pagination": "Page {{page, number}} / {{total, number}}",
  "sidebar_pagination": "Page {{page, number}} · {{count, number}} open",
  "session_ended": "{{title}} (ended)",
  "file_empty": "empty",
  "waiting_for_start": "Waiting for <start>/start</start>",
  "premium_description": "Done-for-you managed service using the Chatcode platform.",
  "this_server": "this server",
  "server_settings_title": "{{name}} settings",
  "sessions_summary": "{{total, number}} total · {{active, number}} active",
  "cores_one": "{{count, number}} core",
  "cores_other": "{{count, number}} cores",
  "telegram_as": "as {{name}}",
  "gateway_update_accepted": "Gateway update to {{version}} accepted. The server will reconnect when ready.",
  "agent_update_accepted": "{{agent}} update to {{version}} accepted.",
  "billing_updated": "Stripe subscription updated.",
  "billing_change_canceled": "Scheduled plan change canceled.",
  "billing_cancellation_scheduled": "Subscription cancellation scheduled.",
  "billing_resumed": "Subscription resumed.",
  "installing_agent": "Installing {{agent}}; the session will appear when it is ready.",
  "creating_agent_session": "Creating {{agent}} session…",
  "installing_agent_short": "Installing {{agent}}…",
  "sidebar_servers": "Servers ({{count, number}})",
  "sidebar_sessions": "Sessions ({{count, number}})",
  "open_server_settings": "Open settings for {{name}}",
  "new_session_in": "New session in {{folder}}",
  "close_named_session": "Close {{name}}",
  "open_sessions_one": "{{count, number}} open session",
  "open_sessions_other": "{{count, number}} open sessions",
  "gateway_online": "online",
  "gateway_offline": "offline",
  "gateway_not_connected": "not connected",
  "leader_explanation": "{{count, number}} Telegram users burn tokens with Chatcode in Codex and Claude Code. Score excludes cached context reads.",
  "file_metadata": "metadata",
  "file_comment": "comment",
  "price_monthly": "{{price}}/mo",
  "price_yearly": "{{price}}/yr",
  "billing_monthly": "monthly",
  "billing_yearly": "yearly",
  "plan_active": "Active plan: {{plan}}",
  "plan_via": "{{interval}} via {{provider}}",
  "plan_change_on": "changes to {{target}} on {{date}}",
  "plan_switches_on": "switches to {{target}} on {{date}}",
  "plan_change_target": "{{plan}} {{interval}}",
  "plan_change_priced": "{{plan}} {{interval}} at {{price}}",
  "plan_ends": "ends {{date}}",
  "plan_renews": "renews {{date}}",
  "plan_payment_issue": "payment issue: access until {{date}}",
  "plan_trial_ends": "trial ends {{date}}",
  "plan_servers_one": "{{count, number}} server",
  "plan_servers_other": "{{count, number}} servers",
  "plan_sessions_one": "{{count, number}} active session",
  "plan_sessions_other": "{{count, number}} active sessions",
  "plan_current": "your current plan",
  "plan_server_limit": "Server limit reached",
  "plan_session_limit": "Session limit reached",
  "plan_limit": "{{plan}} allows {{allowed}}. You currently have {{current, number}}.",
  "plan_limit_upgrade": "Upgrade to {{plan}} to add more.",
  "plan_limit_upgrade_generic": "Upgrade to add more.",
  "plan_limit_remove": "Please remove extra servers until your usage fits the plan, or upgrade to keep creating sessions.",
  "plan_limit_remove_upgrade": "Please remove extra servers until your usage fits the plan, or upgrade to {{plan}} to keep creating sessions.",
  "gateway_update_to": "Update gateway to {{version}}",
  "updating_to": "Updating to {{version}}...",
  "update_to": "Update to {{version}}",
  "gateway_connected_version": "Connected ({{version}})",
  "destroy_confirmation": "This will permanently destroy \"{{name}}\" and all its data. This cannot be undone.",
  "remove_confirmation": "Run cleanup on the host first, then remove \"{{name}}\" from Chatcode. Removing it here does not touch the host itself.",
  "power_off_confirmation": "This will shut down \"{{name}}\" and disconnect all sessions.",
  "switch_plan_title": "Switch to {{plan}}?",
  "switch_plan_stripe_title": "Switch to {{plan}} via Stripe?",
  "stars_stripe_notice": "Your Telegram Stars subscription is active until {{date}}. Its unused value will be applied as a discount to the first Stripe billing period, and Stars auto-renewal will be canceled after Stripe activates.",
  "cancel_subscription_notice": "Your {{plan}} plan stays active until the current billing period ends. Auto-renewal will be turned off.",
  "switch_to_plan": "Switch to {{plan}}",
  "plan_your_price": "{{plan}}: Your Price",
  "plan_choose_price": "Choose {{plan}} price",
  "mac_sleep_one": "This Mac is set to sleep after {{count, number}} minute. Chatcode keeps the gateway awake while it is running, but the gateway can still become unreachable when the lid is closed or the battery runs low.",
  "mac_sleep_other": "This Mac is set to sleep after {{count, number}} minutes. Chatcode keeps the gateway awake while it is running, but the gateway can still become unreachable when the lid is closed or the battery runs low.",
  "sandbox_confirmation": "Sessions on \"{{name}}\" will launch with full access instead of the default sandboxed mode.",
  "agent_option": "{{agent}} will use {{option}}.",
  "agent_missing": "{{agent}} is not installed",
  "agent_install_question": "Install {{agent}} on \"{{name}}\" and continue creating this session?",
  "end_session_confirmation": "This will terminate \"{{name}}\" and any running processes.",
  "session_line": "line {{line}}",
  "session_missing_context": "Missing VPS context for {{session}}.",
  "session_create_hint": "Create a session to start coding.",
  "session_selected_server": "Selected server: {{name}}.",
  "leader_of": "of {{count, number}}",
  "leader_not_yet": "yet",
  "leader_score": "{{metric}} score",
  "leader_fresh_tokens": "fresh tokens",
  "leader_fresh_by_one": "fresh tokens by {{count, number}} user",
  "leader_fresh_by_other": "fresh tokens by {{count, number}} users",
  "faq": "FAQ",
  "onboarding_regular": "Regular",
  "onboarding_premium_intel": "Premium (Intel)",
  "onboarding_premium_amd": "Premium (AMD)",
  "terminal_drop_files": "Drop files to upload into this session folder",
  "terminal_open_link": "Open link",
  "terminal_copy_done": "Copied",
  "terminal_copy": "Copy",
  "terminal_dismiss_clipboard": "Dismiss copied text shortcut",
  "terminal_reconnect": "Reconnect",
  "terminal_input_elsewhere": "Input is active in another connection.",
  "terminal_grab_input": "Grab input",
  "transfer_cancel": "Cancel transfer {{name}}",
  "transfer_dismiss": "Dismiss transfer {{name}}",
  "transfer_cancelled": "Cancelled",
  "transfer_uploaded": "Uploaded {{size}}",
  "transfer_downloaded": "Downloaded {{size}}",
  "transfer_upload_progress": "Uploading {{size}} / {{total}}",
  "transfer_download_progress": "Downloading {{size}} / {{total}}",
  "transfer_uploading": "Uploading...",
  "transfer_downloading": "Downloading...",
  "terminal_copied_one": "Terminal copied {{count, number}} character",
  "terminal_copied_other": "Terminal copied {{count, number}} characters",
  "voice_sent": "Sent",
  "voice_ready": "Ready to send after reconnect.",
  "voice_reconnect_recording": "Reconnect before recording",
  "voice_input_elsewhere": "Input is active elsewhere",
  "view_plans": "View plans",
  "voice_record": "Record voice prompt",
  "voice_send": "Send",
  "voice_cancel_recording": "Cancel recording",
  "voice_resume": "Resume recording",
  "voice_pause": "Pause recording",
  "voice_transcribe_send": "Transcribe and send",
  "voice_reconnect_send": "Reconnect before sending",
  "voice_transcribing": "Transcribing",
  "voice_cancel_transcription": "Cancel transcription",
  "session_folder": "Folder under {{path}}",
  "sandbox_mode": "Sandbox mode",
  "agent": "Agent",
  "agent_shell": "Shell",
  "auth_complete": "Authentication complete",
  "auth_closing_tab": "Closing tab...",
  "auth_close_manually": "The sign-in flow is complete. This tab did not close automatically, so you can close it and return to the app.",
  "auth_close_automatically": "The sign-in flow is complete. This tab should close automatically.",
  "close_tab": "Close tab",
  "app_refreshing": "Refreshing app…",
  "app_reload": "Reload app",
  "app_auto_reloading": "chatcode is reloading to recover from an outdated tab after a deploy.",
  "app_outdated": "This tab is out of date and could not recover automatically. Reload the app to fetch the latest version.",
  "survey_setting_up": "Setting up {{email}}",
  "survey_short_setup": "Short setup",
  "survey_profile": "Profile",
  "survey_heading": "Help us tune Chatcode for your workflow",
  "survey_progress": "{{complete}}/{{total}}",
  "survey_question": "Question {{number}}",
  "survey_optional_detail": "Optional detail",
  "survey_answer_placeholder": "Add your answer",
  "survey_defer_hint": "Skip for this web session. The survey returns after reload or sign-in.",
  "survey_defer": "Do it later",
  "survey_finish": "Finish setup",
  "survey_next": "Next",
  "survey_age": "How old are you?",
  "survey_role": "What best describes you?",
  "survey_build_type": "What do you build most often?",
  "survey_ai_coding_tools": "What do you use for AI coding?",
  "survey_cli_agent_experience": "How experienced are you with command-line coding agents?",
  "survey_interaction_preference": "How do you prefer to work with agents?",
  "survey_discovery": "How did you find Chatcode?",
  "survey_option_under_18": "Under 18",
  "survey_option_founder": "Founder",
  "survey_option_engineer": "IT specialist / engineer",
  "survey_option_researcher": "Researcher / scientist",
  "survey_option_marketing": "Marketing / sales",
  "survey_option_product": "Product manager",
  "survey_option_consultant": "Consultant",
  "survey_option_student": "Student",
  "survey_option_other": "Other",
  "survey_option_web": "Web apps / SaaS",
  "survey_option_consumer": "Consumer apps",
  "survey_option_internal": "Internal / personal tools",
  "survey_option_infrastructure": "Infrastructure",
  "survey_option_data": "Data / AI processing",
  "survey_option_learning": "Learning",
  "survey_option_research": "Research",
  "survey_option_other_cli": "Other CLIs (OpenCode, Gemini, etc.)",
  "survey_option_vibe": "Vibe coding tools (Lovable, Replit, etc.)",
  "survey_option_ides": "IDEs (Cursor, Antigravity, etc.)",
  "survey_option_new_ai": "New to AI coding",
  "survey_option_new_coding": "New to coding",
  "survey_option_heavy": "Heavy user",
  "survey_option_experienced": "Experienced",
  "survey_option_starting_terminal": "Starting (comfortable with terminal)",
  "survey_option_starting_new": "Starting (new to terminal)",
  "survey_option_non_tech": "Far from tech",
  "survey_option_terminal": "Terminal",
  "survey_option_email": "Email",
  "survey_option_search": "Internet search",
  "survey_option_llm": "LLM (ChatGPT, Claude, etc.)",
  "survey_option_word": "Word of mouth",
  "survey_option_social": "Social media (X, Facebook, Instagram)",
  "survey_option_catalog": "Product catalog (Product Hunt, etc.)",
  "survey_option_board": "Web board (Reddit, Hacker News, etc.)",
  "survey_option_news": "News / blog",
  "auth_language_description": "Language on this device. Your account settings apply after sign-in.",
  "beta": "beta",
  "auth_tagline": "Agentic sessions orchestration",
  "auth_check_inbox": "Check your inbox",
  "auth_email_sent": "We sent a sign-in link to {{email}}",
  "auth_different_email": "Use a different email",
  "auth_email_placeholder": "you@example.com",
  "auth_email_label": "Email address",
  "auth_send_link": "Send sign-in link",
  "auth_or": "or",
  "auth_google": "Continue with Google",
  "auth_github": "Continue with GitHub",
  "auth_telegram": "Log in with Telegram",
  "auth_agreement": "By signing up or continuing, you agree to the <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  "settings_appearance": "Appearance",
  "settings_color_scheme": "Color Scheme",
  "settings_terminal_theme": "Terminal Theme",
  "settings_language": "Language",
  "settings_language_description": "Used across Chatcode and linked Telegram bots. Automatic follows your browser or Telegram language.",
  "settings_language_preview": "Translation preview: please report wording or layout issues.",
  "settings_language_error": "Could not save your language. Your previous language has been restored.",
  "theme_system": "System",
  "theme_label": "Color Scheme: {{theme}}",
  "theme_dark": "Dark",
  "theme_light": "Light",
  "support_title": "Ask support",
  "support_description": "Need a hand or have feedback? Browse public issues or message the creator directly.",
  "support_github": "Bugs & feature requests",
  "support_github_detail": "Browse or report public issues on GitHub",
  "support_close": "Close support",
  "support_telegram": "DM on Telegram",
  "support_whatsapp": "DM on WhatsApp",
  "support_email": "Send an email",
  "connection_connecting": "Connecting…",
  "connection_reconnecting": "Reconnecting…",
  "auth_unavailable_title": "Can’t reach Chatcode",
  "auth_unavailable_description": "We’ll keep trying. Check your connection or try again now.",
  "pseudo_language": "Expanded English (test)",
  "copy_set_up_your_server": "Set up your server",
  "copy_existing_servers_stay_available_new_creation_is_blocked_until_your_usage_fits_the_current_": "Existing servers stay available. New creation is blocked until your usage fits the current plan.",
  "copy_view_plans": "View plans",
  "copy_choose_how_you_want_to_run_your_coding_environment": "Choose how you want to run your coding environment.",
  "copy_digitalocean_droplet": "DigitalOcean Droplet",
  "copy_one_click_setup_we_create_and_manage_a_droplet_in_your_do_account_starting_at_4_mo": "One-click setup. We create and manage a droplet in your DO account. Starting at ~$4/mo.",
  "copy_bring_your_own_server": "Bring Your Own Server",
  "copy_connect_any_linux_or_macos_machine_you_already_own": "Connect any Linux or macOS machine you already own.",
  "copy_label_optional": "Label (optional)",
  "copy_loading_current_digitalocean_regions_sizes_and_linux_images": "Loading current DigitalOcean regions, sizes, and Linux images...",
  "copy_region": "Region",
  "copy_droplet_type": "Droplet Type",
  "copy_specs": "Specs",
  "copy_this_droplet_type_is_not_available_in_the_selected_region_try_another_region_or_type": "This droplet type is not available in the selected region. Try another region or type.",
  "copy_retry_loading_catalog": "Retry loading catalog",
  "copy_create_droplet": "Create Droplet",
  "copy_link_digitalocean": "Link DigitalOcean",
  "copy_compute_billing_starts_immediately": "Compute billing starts immediately.",
  "copy_digitalocean_opens_in_a_separate_tab_after_linking_return_here_to_create_the_droplet": "DigitalOcean opens in a separate tab. After linking, return here to create the droplet.",
  "copy_showing_default_digitalocean_options_until_your_account_is_linked": "Showing default DigitalOcean options until your account is linked.",
  "copy_connect_your_server": "Connect your server",
  "copy_need_a_vps": "Need a VPS?",
  "copy_recommended_baseline_2_vcpu_4_gb_ram_or_better": "Recommended baseline: 2 vCPU / 4 GB RAM or better.",
  "copy_we_may_use_affiliate_links_here_provider_billing_and_support_stay_between_you_and_the_prov": "We may use affiliate links here. Provider billing and support stay between you and the provider.",
  "copy_server_name": "Server name",
  "copy_server_name_is_locked_for_this_generated_install_command_you_can_change_it_later": "Server name is locked for this generated install command. You can change it later.",
  "copy_generating_command": "Generating command...",
  "copy_regenerate_install_command": "Regenerate install command",
  "copy_generate_install_command": "Generate install command",
  "copy_run_this_command_on_your_server": "Run this command on your server:",
  "copy_copied": "Copied",
  "copy_copy_command": "Copy command",
  "copy_done": "Done",
  "copy_the_install_command_will": "The install command will:",
  "copy_install_tmux_and_the_gateway_daemon": "Install tmux and the gateway daemon",
  "copy_set_up_a_service_systemd_launchd": "Set up a service (systemd/launchd)",
  "copy_register_the_server_to_your_account": "Register the server to your account",
  "copy_your_server_will_appear_in_the_sidebar_once_connected": "Your server will appear in the sidebar once connected.",
  "copy_creating_your_droplet": "Creating your droplet...",
  "copy_this_usually_takes_1_2_minutes_the_gateway_will_connect_automatically": "This usually takes 1-2 minutes. The gateway will connect automatically.",
  "copy_back_to_main_view": "Back to main view",
  "copy_provisioning_progress_will_stay_visible_there": "Provisioning progress will stay visible there.",
  "copy_server_settings": "Server settings",
  "copy_settings": "Settings",
  "copy_powering_on": "Powering on...",
  "copy_powering_off": "Powering off...",
  "copy_power_off": "Power off",
  "copy_power_on": "Power on",
  "copy_gateway": "Gateway",
  "copy_platform": "Platform",
  "copy_provider": "Provider",
  "copy_sessions": "Sessions",
  "copy_portable_mac_note": "Portable Mac note.",
  "copy_approximate_pricing_as_of_march_2026_estimated_cost": "Approximate pricing as of March 2026. Estimated cost:",
  "copy_digitalocean_dashboard": "DigitalOcean Dashboard",
  "copy_overview": "Overview",
  "copy_hardware": "Hardware",
  "copy_ip_address": "IP address",
  "copy_server_id": "Server ID",
  "copy_gateway_id": "Gateway ID",
  "copy_vendor": "Vendor",
  "copy_host_type": "Host Type",
  "copy_model": "Model",
  "copy_model_code": "Model Code",
  "copy_chip": "Chip",
  "copy_architecture": "Architecture",
  "copy_cpu_cores": "CPU Cores",
  "copy_memory": "Memory",
  "copy_disk": "Disk",
  "copy_installed_agents": "Installed agents",
  "copy_no_agent_data_available_yet": "No agent data available yet.",
  "copy_installed": "Installed",
  "copy_version_unknown": "Version unknown",
  "copy_latest": "Latest",
  "copy_install_command": "Install command",
  "copy_run_this_on_the_host_to_finish_connecting_this_server_to_chatcode": "Run this on the host to finish connecting this server to Chatcode.",
  "copy_refreshing": "Refreshing...",
  "copy_refresh_command": "Refresh command",
  "copy_failed_to_load_install_command": "Failed to load install command:",
  "copy_set_up_a_service_using_systemd_or_launchd": "Set up a service using systemd or launchd",
  "copy_register_the_host_to_this_chatcode_account": "Register the host to this Chatcode account",
  "copy_generating_install_command": "Generating install command...",
  "copy_recent_sessions": "Recent sessions",
  "copy_previous_page": "Previous page",
  "copy_next_page": "Next page",
  "copy_no_sessions_yet": "No sessions yet.",
  "copy_copy": "Copy",
  "copy_last_active": "Last active",
  "copy_server_actions": "Server actions",
  "copy_destroy_server": "Destroy server",
  "copy_remove_server": "Remove server",
  "copy_permanently_destroy_this_server_and_all_of_its_data": "Permanently destroy this server and all of its data.",
  "copy_run_cleanup_on_the_host_first_then_remove_this_manual_server_from_chatcode_without_touchin": "Run cleanup on the host first, then remove this manual server from chatcode without touching the host itself.",
  "copy_destroying": "Destroying...",
  "copy_removing": "Removing...",
  "copy_loading_server_settings": "Loading server settings...",
  "copy_this_server_is_no_longer_available": "This server is no longer available.",
  "copy_account": "Account",
  "copy_email": "Email",
  "copy_not_linked": "Not linked",
  "copy_connect": "Connect",
  "copy_plan": "Plan",
  "copy_scheduled_change": "Scheduled change:",
  "copy_canceling": "Canceling...",
  "copy_cancel_change": "Cancel change",
  "copy_most_popular": "Most popular",
  "copy_premium": "Premium",
  "copy_learn_more": "Learn more",
  "copy_hosted_billing_is_disabled_on_this_deployment_local_entitlements_are_controlled_by_the_ope": "Hosted billing is disabled on this deployment. Local entitlements are controlled by the operator.",
  "copy_open_bot": "Open bot",
  "copy_status": "Status",
  "copy_unlinked": "Unlinked",
  "copy_connected": "Connected",
  "copy_waiting": "Waiting",
  "copy_signed_in_devices": "Signed-in Devices",
  "copy_review_where_this_account_is_currently_signed_in": "Review where this account is currently signed in.",
  "copy_loading_signed_in_devices": "Loading signed-in devices...",
  "copy_no_active_device_sessions_found": "No active device sessions found.",
  "copy_unknown_device": "Unknown device",
  "copy_current": "Current",
  "copy_signing_out": "Signing out...",
  "copy_sign_out": "Sign out",
  "copy_signing_out_all_other_devices": "Signing out all other devices...",
  "copy_sign_out_all_other_devices": "Sign out all other devices",
  "copy_run_this_on_the_host_before_removing_the_server": "Run this on the host before removing the server:",
  "copy_if_active_chatcode_tmux_sessions_are_found_cleanup_can_ask_whether_to_keep_or_remove_them": "If active Chatcode tmux sessions are found, cleanup can ask whether to keep or remove them.",
  "copy_power_off_server": "Power off server",
  "copy_unlink_telegram": "Unlink Telegram?",
  "copy_your_telegram_account_will_be_disconnected_manager_topics_will_be_closed_managed_bots_will": "Your Telegram account will be disconnected. Manager topics will be closed, managed bots will be unlinked from this account, and their session topics will be closed. You can link Telegram again later.",
  "copy_unlink_telegram_2": "Unlink Telegram",
  "copy_adjust_plus_price": "Adjust Plus price?",
  "copy_the_new_plus_price_starts_from_the_next_billing_cycle": "The new Plus price starts from the next billing cycle.",
  "copy_upgrades_apply_immediately_with_prorated_billing_downgrades_and_yearly_to_monthly_changes_": "Upgrades apply immediately with prorated billing. Downgrades and yearly-to-monthly changes are scheduled for the end of the current billing cycle.",
  "copy_adjust_price": "Adjust price",
  "copy_switch_plan": "Switch plan",
  "copy_continue_to_stripe": "Continue to Stripe",
  "copy_cancel_subscription": "Cancel Subscription?",
  "copy_cancel_subscription_2": "Cancel Subscription",
  "copy_switch_to_stripe": "Switch to Stripe",
  "copy_select": "Select",
  "copy_saving": "Saving...",
  "copy_adjust_price_2": "Adjust Price",
  "copy_opening": "Opening...",
  "copy_manage_billing": "Manage Billing",
  "copy_switching": "Switching...",
  "copy_you_can_adjust_this_later_from_plan_settings": "You can adjust this later from Plan settings.",
  "copy_price_increases_apply_immediately_with_proration_decreases_start_from_the_next_billing_cyc": "Price increases apply immediately with proration. Decreases start from the next billing cycle.",
  "copy_choose_the_recurring_amount_that_feels_right": "Choose the recurring amount that feels right.",
  "copy_current_price": "Current price",
  "copy_continue": "Continue",
  "copy_resume_subscription": "Resume Subscription",
  "copy_all_prices_exclude_vat_tax_is_added_where_applicable": "All prices exclude VAT. Tax is added where applicable.",
  "copy_updating": "Updating...",
  "copy_appearance": "Appearance",
  "copy_security": "Security",
  "copy_free": "Free",
  "copy_your_price": "Your Price",
  "copy_voice_mode": "· voice mode",
  "copy_priority_support": "+ priority support",
  "copy_yearly_only": "› yearly only:",
  "copy_community": "+ community",
  "copy_source_contributions": "+ source & contributions",
  "copy_active_plan_loading": "Active plan: Loading...",
  "copy_link_account": "Link account",
  "copy_linked": "Linked",
  "copy_unlinking": "Unlinking...",
  "copy_unlink": "Unlink",
  "copy_manual_server": "Manual server",
  "copy_unknown": "Unknown",
  "copy_chatcode_keeps_the_gateway_awake_while_it_is_running_but_this_portable_mac_can_still_becom": "Chatcode keeps the gateway awake while it is running, but this portable Mac can still become unreachable when the lid is closed or the battery runs low.",
  "copy_ethernet": "Ethernet",
  "copy_portable": "Portable",
  "copy_desktop": "Desktop",
  "copy_single_board": "Single-board",
  "copy_server": "Server",
  "copy_server_is_booting": "Server is booting",
  "copy_server_is_powered_off": "Server is powered off",
  "copy_terminal_sessions_are_paused_until_the_droplet_finishes_booting_and_the_gateway_reconnects": "Terminal sessions are paused until the droplet finishes booting and the gateway reconnects.",
  "copy_terminal_sessions_are_paused_because_this_droplet_is_powered_off": "Terminal sessions are paused because this droplet is powered off.",
  "copy_server_is_offline": "Server is offline",
  "copy_terminal_sessions_are_paused_until_the_gateway_reconnects_existing_tabs_are_kept_for_resto": "Terminal sessions are paused until the gateway reconnects. Existing tabs are kept for restore.",
  "copy_reconnect_and_refresh_terminal": "Reconnect and refresh terminal",
  "copy_force_refresh_from_gateway_snapshot": "Force refresh from gateway snapshot",
  "copy_this_session_is_no_longer_available": "This session is no longer available.",
  "copy_existing_servers_and_sessions_stay_available_new_creation_is_blocked_until_your_usage_fits": "Existing servers and sessions stay available. New creation is blocked until your usage fits the current plan.",
  "copy_disable_sandbox_mode": "Disable sandbox mode?",
  "copy_disable_sandbox": "Disable sandbox",
  "copy_codex_will_use_full_access_with_approvals_disabled": "Codex will use full access with approvals disabled.",
  "copy_chatcode_will_install_the_missing_agent_wait_for_it_to_become_available_and_then_retry_ses": "chatcode will install the missing agent, wait for it to become available, and then retry session creation automatically.",
  "copy_this_is_usually_quick_but_small_hosts_can_take_a_minute_or_two": "This is usually quick, but small hosts can take a minute or two.",
  "copy_install_and_continue": "Install and continue",
  "copy_dismiss": "Dismiss",
  "copy_open_menu": "Open menu",
  "copy_close_tab": "Close tab",
  "copy_creating": "Creating...",
  "copy_new_session": "New Session",
  "copy_booting_droplet_gateway_will_connect_shortly": "Booting droplet... gateway will connect shortly",
  "copy_welcome_to_chatcode_dev": "Welcome to chatcode.dev",
  "copy_set_up_a_vps_to_get_started_with_ai_powered_terminal_sessions": "Set up a VPS to get started with AI-powered terminal sessions.",
  "copy_telegram_connected": "Telegram connected",
  "copy_telegram_linked_open_the_bot_and_send_start_to_connect": "Telegram linked. Open the bot and send /start to connect.",
  "copy_expand_sidebar": "Expand sidebar",
  "copy_collapse_sidebar": "Collapse sidebar",
  "copy_expand_server_list": "Expand server list",
  "copy_collapse_server_list": "Collapse server list",
  "copy_servers": "Servers",
  "copy_add_your_first_server": "+ Add your first server",
  "copy_add_server": "Add server",
  "copy_refresh_sessions_and_folders": "Refresh sessions and folders",
  "copy_refreshing_sessions": "Refreshing sessions",
  "copy_new_session_2": "New session",
  "copy_server_must_be_connected_to_create_sessions": "Server must be connected to create sessions",
  "copy_no_sessions_yet_2": "No sessions yet",
  "copy_end_session": "End session",
  "copy_newer": "Newer",
  "copy_older": "Older",
  "copy_link_telegram": "Link Telegram",
  "copy_dismiss_error": "Dismiss error",
  "copy_day": "Day",
  "copy_week": "Week",
  "copy_month": "Month",
  "copy_year": "Year",
  "copy_total": "Total",
  "copy_join_the_chatcode_channel_to_open_the_top_chart": "Join the Chatcode channel to open the top chart.",
  "copy_leaderboard_is_warming_up": "Leaderboard is warming up.",
  "copy_open_from_telegram": "Open from Telegram",
  "copy_this_mini_app_only_works_inside_the_chatcode_telegram_bot": "This Mini App only works inside the Chatcode Telegram bot.",
  "copy_opening_chatcode": "Opening Chatcode…",
  "copy_preparing_the_telegram_mini_app": "Preparing the Telegram Mini App.",
  "copy_burned_today": "Burned today",
  "copy_no_rank": "No rank",
  "copy_streak": "Streak",
  "copy_top_chart": "Top chart",
  "copy_loading": "Loading",
  "copy_managed_bots": "Managed bots",
  "copy_no_managed_bots_yet": "No managed bots yet.",
  "copy_what_is_chatcode": "What is Chatcode?",
  "copy_chatcode_connects_coding_agents_to_telegram_and_the_web_link_your_account_set_up_telegram_": "Chatcode connects coding agents to Telegram and the web. Link your account, set up Telegram, and join other builders in pursuit of coding perfection.",
  "copy_sign_in_or_link_telegram_from_the_web_app_to_show_your_own_score_plan_managed_bots_and_str": "Sign in or link Telegram from the web app to show your own score, plan, managed bots, and streak here.",
  "copy_account_email": "Account email",
  "copy_open_web_app": "Open web app",
  "copy_partner_link": "Partner link",
  "copy_stars_revenue_share": "Stars revenue share",
  "copy_small_answers": "Small answers",
  "copy_plan_and_account": "Plan and account",
  "copy_news_channel": "News channel",
  "copy_feedback": "Feedback",
  "copy_feedback_coming_soon": "Feedback coming soon",
  "copy_contact_thatguy": "Contact @thatguy",
  "copy_contact_link_is_not_configured": "Contact link is not configured",
  "copy_no_token_usage_yet_for_this_period": "No token usage yet for this period.",
  "copy_loading_chart": "Loading chart…",
  "copy_counting_tokens": "Counting tokens.",
  "copy_join_chatcode_to_see_the_chart": "Join Chatcode to see the chart",
  "copy_open_channel": "Open channel",
  "copy_reload": "Reload",
  "copy_your_rank": "Your rank",
  "copy_partner_link_2": "Partner Link",
  "copy_earn_50_from_invited_users_telegram_stars_transactions_for_3_years": "Earn 50% from invited users' Telegram Stars transactions for 3 years.",
  "copy_bring_builders_share_the_upside": "Bring builders. Share the upside.",
  "copy_open_the_bot_profile_join_the_telegram_partnership_flow_and_get_your_personal_invite_link": "Open the bot profile, join the Telegram partnership flow, and get your personal invite link.",
  "copy_the_affiliate_program_applies_to_telegram_stars_transactions_only": "The affiliate program applies to Telegram Stars transactions only.",
  "copy_bot_profile_links_are_not_configured_in_this_build_open_the_manager_bot_in_telegram_manual": "Bot profile links are not configured in this build. Open the manager bot in Telegram manually to request a partner link.",
  "copy_get_your_link": "Get your link",
  "copy_bot_profile_unavailable": "Bot profile unavailable",
  "copy_short_answers_about_chatcode_and_the_telegram_mini_apps": "Short answers about Chatcode and the Telegram Mini Apps.",
  "copy_main_idea": "Main idea",
  "copy_chatcode_gives_you_a_remote_coding_workspace_connected_to_web_and_telegram_interfaces": "Chatcode gives you a remote coding workspace connected to web and Telegram interfaces.",
  "copy_where_code_runs": "Where code runs",
  "copy_your_terminal_sessions_run_on_your_own_provisioned_server_the_control_plane_coordinates_ac": "Your terminal sessions run on your own provisioned server. The control plane coordinates access, limits, and updates.",
  "copy_gateway_and_sessions": "Gateway and sessions",
  "copy_a_small_gateway_process_runs_on_the_server_and_keeps_one_secure_connection_back_to_chatcod": "A small gateway process runs on the server and keeps one secure connection back to Chatcode.",
  "copy_each_session_is_a_tmux_backed_terminal_rooted_in_your_workspace_so_reconnecting_from_web_o": "Each session is a tmux-backed terminal rooted in your workspace, so reconnecting from web or Telegram can continue the same work.",
  "copy_agents_and_token_score": "Agents and token score",
  "copy_agents": "Agents",
  "copy_codex_and_claude_code_activity_is_read_from_local_transcripts_when_available_then_mirrored": "Codex and Claude Code activity is read from local transcripts when available, then mirrored to Telegram topics.",
  "copy_burned_tokens": "Burned tokens",
  "copy_the_score_counts_fresh_coding_activity_and_excludes_cached_context_reads_so_cached_prompts": "The score counts fresh coding activity and excludes cached context reads, so cached prompts do not dominate the chart.",
  "copy_telegram_setup": "Telegram setup",
  "copy_bot_structure": "Bot structure",
  "copy_the_manager_bot_is_the_account_hub_each_managed_bot_belongs_to_one_server_and_handles_serv": "The manager bot is the account hub. Each managed bot belongs to one server and handles server-specific sessions.",
  "copy_set_up_a_managed_bot": "Set up a managed bot",
  "copy_chatcode_creates_the_managed_bot_after_a_simple_confirmation_then_open_botfather_for_that_": "Chatcode creates the managed bot after a simple confirmation. Then open BotFather for that bot and enable threaded mode so session topics can work.",
  "copy_start_working": "Start working",
  "copy_open_the_managed_bot_create_or_reopen_a_session_and_use_the_session_mini_app_for_terminal_": "Open the managed bot, create or reopen a session, and use the session Mini App for terminal work, voice input, and file previews.",
  "copy_mini_apps": "Mini Apps",
  "copy_main_app": "Main app",
  "copy_this_app_shows_your_account_token_chart_partner_link_and_quick_settings": "This app shows your account, token chart, partner link, and quick settings.",
  "copy_server_app": "Server app",
  "copy_server_mini_apps_list_sessions_for_one_server_and_let_you_create_new_sessions_when_your_pl": "Server Mini Apps list sessions for one server and let you create new sessions when your plan allows it.",
  "copy_session_app": "Session app",
  "copy_session_links_open_a_terminal_focused_mini_app_with_keyboard_helpers_voice_controls_and_li": "Session links open a terminal-focused Mini App with keyboard helpers, voice controls, and live session output.",
  "copy_preview_app": "Preview app",
  "copy_file_preview_links_use_a_separate_direct_link_mini_app_so_previews_stay_focused_and_lightw": "File preview links use a separate direct-link Mini App so previews stay focused and lightweight.",
  "copy_files_and_privacy": "Files and privacy",
  "copy_file_previews": "File previews",
  "copy_preview_links_are_meant_for_quick_viewing_from_telegram_and_keep_the_main_app_separate_fro": "Preview links are meant for quick viewing from Telegram and keep the main app separate from file content.",
  "copy_public_chart": "Public chart",
  "copy_the_top_chart_uses_public_telegram_display_names_and_token_scores_email_server_names_and_w": "The top chart uses public Telegram display names and token scores. Email, server names, and workspace paths are not shown there.",
  "copy_compact_info_heavy_controls_stay_in_the_web_app": "Compact info. Heavy controls stay in the web app.",
  "copy_this_chat": "This chat",
  "copy_plan_settings": "Plan settings",
  "copy_web_settings": "Web settings",
  "copy_managed_bot": "Managed bot",
  "copy_server_bot": "Server bot",
  "copy_complete_setup": "Complete setup",
  "copy_manager_topic_unavailable": "Manager topic unavailable",
  "copy_reusable_bot": "Reusable bot",
  "copy_waiting_for_telegram_launch_data": "Waiting for Telegram launch data…",
  "copy_opening_server": "Opening server…",
  "copy_server_unavailable": "Server unavailable",
  "copy_preparing_telegram_server_access": "Preparing Telegram server access.",
  "copy_refresh_sessions": "Refresh sessions",
  "copy_create_or_reopen_sessions_for_this_server": "Create or reopen sessions for this server.",
  "copy_hide": "Hide",
  "copy_create": "Create",
  "copy_existing_folders": "Existing folders",
  "copy_no_open_sessions_yet": "No open sessions yet.",
  "copy_close_session": "Close session",
  "copy_voice_mode_requires_starter": "Voice mode requires Starter",
  "copy_voice_transcription_is_available_on_starter_and_higher_plans": "Voice transcription is available on Starter and higher plans.",
  "copy_session_link_is_incomplete": "Session link is incomplete.",
  "copy_authorizing_terminal": "Authorizing terminal…",
  "copy_terminal_unavailable": "Terminal unavailable",
  "copy_preparing_telegram_session_access": "Preparing Telegram session access.",
  "copy_copy_session_id": "Copy session id",
  "copy_session_id_copied": "Session id copied",
  "copy_session_id": "Session ID",
  "copy_refresh_terminal": "Refresh terminal",
  "copy_upgrade": "Upgrade",
  "copy_refreshing_telegram_session_access": "Refreshing Telegram session access…",
  "copy_preview_unavailable": "Preview unavailable.",
  "copy_file_preview": "File preview",
  "copy_opening_from_telegram": "Opening from Telegram",
  "copy_decrease_preview_text_size": "Decrease preview text size",
  "copy_smaller_text": "Smaller text",
  "copy_increase_preview_text_size": "Increase preview text size",
  "copy_larger_text": "Larger text",
  "copy_download_file": "Download file",
  "copy_download": "Download",
  "copy_opening_file": "Opening file…",
  "copy_preview_unavailable_2": "Preview unavailable",
  "copy_copy_unavailable": "Copy unavailable",
  "copy_copy_ref": "Copy @ref",
  "copy_pdf_preview_is_not_available_in_this_telegram_client_use_download": "PDF preview is not available in this Telegram client. Use Download.",
  "copy_file_reference_cannot_be_opened": "File reference cannot be opened.",
  "copy_this_file_type_can_be_downloaded_but_it_cannot_be_previewed_inline_yet": "This file type can be downloaded, but it cannot be previewed inline yet.",
  "copy_completed": "Completed",
  "copy_not_completed": "Not completed",
  "copy_link_cannot_be_opened": "Link cannot be opened.",
  "copy_server_state_unavailable": "Server state unavailable.",
  "copy_server_state_unavailable_2": "Server state unavailable",
  "copy_refresh_the_server_list_and_try_again": "Refresh the server list and try again.",
  "copy_provisioning": "Provisioning",
  "copy_creating_the_droplet_and_installing_the_gateway": "Creating the droplet and installing the gateway.",
  "copy_server_is_provisioning": "Server is provisioning",
  "copy_this_server_is_still_being_created_and_prepared_sessions_will_be_available_once_the_gatewa": "This server is still being created and prepared. Sessions will be available once the gateway checks in.",
  "copy_setup_stalled": "Setup stalled",
  "copy_gateway_did_not_check_in_after_provisioning": "Gateway did not check in after provisioning.",
  "copy_server_setup_needs_attention": "Server setup needs attention",
  "copy_the_droplet_was_created_but_the_gateway_did_not_connect_in_time_check_server_settings_befo": "The droplet was created, but the gateway did not connect in time. Check server settings before creating sessions.",
  "copy_ready": "Ready",
  "copy_gateway_connected": "Gateway connected.",
  "copy_no_active_sessions": "No active sessions",
  "copy_needs_install": "Needs install",
  "copy_run_the_install_command_from_server_settings": "Run the install command from server settings.",
  "copy_finish_connecting_this_server": "Finish connecting this server",
  "copy_this_host_is_registered_but_not_installed_yet_run_the_install_command_from_server_settings": "This host is registered but not installed yet. Run the install command from server settings before creating sessions.",
  "copy_offline": "Offline",
  "copy_gateway_disconnected": "Gateway disconnected.",
  "copy_reconnect_the_gateway_before_creating_sessions": "Reconnect the gateway before creating sessions.",
  "copy_finishing_setup": "Finishing setup",
  "copy_droplet_is_up_waiting_for_the_gateway": "Droplet is up. Waiting for the gateway.",
  "copy_server_is_still_getting_ready": "Server is still getting ready",
  "copy_the_machine_is_up_but_the_gateway_has_not_connected_yet_this_usually_settles_within_a_minu": "The machine is up, but the gateway has not connected yet. This usually settles within a minute or two.",
  "copy_powered_off": "Powered off",
  "copy_power_the_droplet_back_on_to_reconnect": "Power the droplet back on to reconnect.",
  "copy_power_this_droplet_back_on_before_creating_sessions": "Power this droplet back on before creating sessions.",
} as const;
